// Data and helpers shared by every module.

export const img = (id, w = 800) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=70`;

export const services = [
  { key: 'flights', label: 'Flights', path: '/flights', prefix: 'FL', noun: 'Flight' },
  { key: 'hotels', label: 'Hotels', path: '/hotels', prefix: 'HT', noun: 'Hotel' },
  { key: 'packages', label: 'Holidays', path: '/packages', prefix: 'HL', noun: 'Holiday' },
  { key: 'sightseeing', label: 'Activities', path: '/sightseeing', prefix: 'SS', noun: 'Activity' },
  { key: 'transfers', label: 'Transfers', path: '/transfers', prefix: 'TR', noun: 'Transfer' },
  { key: 'insurance', label: 'Insurance', path: '/insurance', prefix: 'IN', noun: 'Insurance' },
  { key: 'bus', label: 'Bus', path: '/bus', prefix: 'BS', noun: 'Bus' },
];

export const serviceOf = (key) => services.find((s) => s.key === key);

/** Company details shown in the footer, on tickets and vouchers, and in the policies. */
export const company = {
  name: 'SAAR DEVELOPERS CODE PRIVATE LIMITED',
  brand: 'Trawtel',
  phone: '1800-123-4567',
  phoneHref: 'tel:18001234567',
  // TODO: fill in before going live; the policies show these as the legal contact details.
  address: '[Registered office address]',
  supportEmail: 'support@trawtel.com',
  grievanceOfficer: { name: '[Grievance Officer name]', email: '[grievance email]' },
  policiesUpdated: '2026-10-23',
};

export const places = [
  { city: 'Delhi', code: 'DEL', airport: 'Indira Gandhi International Airport', country: 'India', lat: 28.6139, lng: 77.209 },
  { city: 'Mumbai', code: 'BOM', airport: 'Chhatrapati Shivaji Maharaj Intl Airport', country: 'India', lat: 19.076, lng: 72.8777 },
  { city: 'Bengaluru', code: 'BLR', airport: 'Kempegowda International Airport', country: 'India', lat: 12.9716, lng: 77.5946 },
  { city: 'Goa', code: 'GOI', airport: 'Dabolim Airport', country: 'India', lat: 15.4909, lng: 73.8278 },
  { city: 'Chennai', code: 'MAA', airport: 'Chennai International Airport', country: 'India', lat: 13.0827, lng: 80.2707 },
  { city: 'Kolkata', code: 'CCU', airport: 'Netaji Subhas Chandra Bose Intl Airport', country: 'India', lat: 22.5726, lng: 88.3639 },
  { city: 'Hyderabad', code: 'HYD', airport: 'Rajiv Gandhi International Airport', country: 'India', lat: 17.385, lng: 78.4867 },
  { city: 'Jaipur', code: 'JAI', airport: 'Jaipur International Airport', country: 'India', lat: 26.9124, lng: 75.7873 },
  { city: 'Agra', code: 'AGR', airport: 'Agra Airport', country: 'India', lat: 27.1767, lng: 78.0081 },
  { city: 'Dubai', code: 'DXB', airport: 'Dubai International Airport', country: 'UAE', lat: 25.2048, lng: 55.2708 },
  { city: 'Singapore', code: 'SIN', airport: 'Changi Airport', country: 'Singapore', lat: 1.2903, lng: 103.852 },
  { city: 'Bangkok', code: 'BKK', airport: 'Suvarnabhumi Airport', country: 'Thailand', lat: 13.7563, lng: 100.5018 },
  { city: 'Bali', code: 'DPS', airport: 'Ngurah Rai International Airport', country: 'Indonesia', lat: -8.65, lng: 115.2167 },
  { city: 'London', code: 'LHR', airport: 'Heathrow Airport', country: 'United Kingdom', lat: 51.5074, lng: -0.1278 },
  { city: 'Paris', code: 'CDG', airport: 'Charles de Gaulle Airport', country: 'France', lat: 48.8566, lng: 2.3522 },
  { city: 'Tokyo', code: 'HND', airport: 'Haneda Airport', country: 'Japan', lat: 35.6762, lng: 139.6503 },
  { city: 'Maldives', code: 'MLE', airport: 'Velana International Airport', country: 'Maldives', lat: 4.1755, lng: 73.5093 },
];

export const placeOf = (city) => places.find((p) => p.city === city) || { city, code: '', airport: '', country: '' };
export const isInternational = (...cities) => cities.some((c) => c && placeOf(c).country && placeOf(c).country !== 'India');

export const destinations = [
  { name: 'Bali', country: 'Indonesia', tagline: 'Island of Gods', from: 22999, image: img('1537996194471-e657df975ab4', 600) },
  { name: 'Dubai', country: 'UAE', tagline: 'City of Gold', from: 18499, image: img('1512453979798-5ea266f8880c', 600) },
  { name: 'Paris', country: 'France', tagline: 'City of Love', from: 64999, image: img('1502602898657-3e91760cbb34', 600) },
  { name: 'Maldives', country: 'Maldives', tagline: 'Turquoise Paradise', from: 49999, image: img('1514282401047-d79a71a590e8', 600) },
  { name: 'Singapore', country: 'Singapore', tagline: 'Lion City', from: 27999, image: img('1525625293386-3f8f99389edd', 600) },
  { name: 'Tokyo', country: 'Japan', tagline: 'Neon & Nature', from: 72999, image: img('1540959733332-eab4deabeeaf', 600) },
];

export const offers = [
  { code: 'FLYFRESH', category: 'Flights', module: 'flights', title: 'Flat 12% off on domestic & international flights', desc: 'Valid on all airlines. Max discount ₹2,500.', image: img('1436491865332-7a61a109cc05', 500) },
  { code: 'STAYCOOL', category: 'Hotels', module: 'hotels', title: 'Up to 30% off on 5,000+ handpicked hotels', desc: 'Weekend getaways & long stays. Max discount ₹4,000.', image: img('1566073771259-6a8506099945', 500) },
  { code: 'HOLIDAY5K', category: 'Holidays', module: 'packages', title: 'Save ₹5,000 on international holidays', desc: 'On packages above ₹40,000 per booking.', image: img('1537996194471-e657df975ab4', 500) },
  { code: 'FUNDAY', category: 'Sightseeing', module: 'sightseeing', title: '10% off on tours & attraction tickets', desc: 'Theme parks, landmarks, cruises & more.', image: img('1451337516015-6b6e9a44a8a3', 500) },
  { code: 'RIDE200', category: 'Transfers', module: 'transfers', title: 'Flat ₹200 off on airport transfers', desc: 'On private cab bookings above ₹1,200.', image: img('1449965408869-eaa3f722e40d', 500) },
  { code: 'SAFE15', category: 'Insurance', module: 'insurance', title: '15% off on travel insurance', desc: 'All plans, all destinations.', image: img('1488646953014-85cb44e25828', 500) },
];
// Promo code rules live in the API (admin → Promo codes); these are only the advertised banners.

// formatPrice: an INR amount in the customer's display currency. formatINR: amounts charged or refunded.
export { formatCharge, formatINR, formatPrice } from '../currency/currencyStore';

// ---- dates ----
const pad = (n) => String(n).padStart(2, '0');
export const toIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayIso = () => toIso(new Date());
export const addDaysIso = (n, from) => {
  const d = from ? parseIso(from) : new Date();
  d.setDate(d.getDate() + n);
  return toIso(d);
};
export const parseIso = (s) => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d || 1); };
export const daysBetween = (a, b) => Math.round((parseIso(b) - parseIso(a)) / 86400000);
export const fmtDate = (s, opts = { day: 'numeric', month: 'short', year: 'numeric' }) =>
  s ? parseIso(s).toLocaleDateString('en-IN', opts) : '—';
export const fmtDay = (s) => fmtDate(s, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
